{
    "firebase": {
        "apiKey": "AIzaSyBu9txqgbNStiV1QmGZtBawywuUdP2KHHM",
        "authDomain": "flowise-test-30c33.firebaseapp.com",
        "databaseURL": "https://flowise-test-30c33-default-rtdb.firebaseio.com",
        "projectId": "flowise-test-30c33",
        "storageBucket": "flowise-test-30c33.firebasestorage.app",
        "messagingSenderId": "91380858542",
        "appId": "1:91380858542:web:6a9cf5fabd6e551718773f"
    },
    "clientName": "Flowise Test Env Environment",
    "pdfViewerKey": "71b71910e00f4cb485d49d628413168b",
    "domains": ["flowise-test-30c33.web.app"],
    "flowise_url": "https://flowise-test.flightlinedata.com",
    "flowise_api_key": "PhkgUfG2bBlOGgp7mmuXjQgQvBnXWGZSGTkBbwFRnDE"
}
